<div class="create-parking-space-wizard p-6 max-w-7xl mx-auto">
    <div class="flex items-center justify-between mb-6">
        <h1 class="text-3xl font-bold text-gray-900">Create Parking Space</h1>
        <button mat-icon-button (click)="goBack()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Progress Stepper -->
    <jjames-card class="mb-6">
        <div class="p-4">
            <div class="flex items-center justify-between">
                @for (step of [
                {num: 0, label: 'Basic Information', icon: 'info'},
                {num: 1, label: 'Infrastructure', icon: 'developer_board'},
                {num: 2, label: 'Device Groups', icon: 'device_hub'},
                {num: 3, label: 'Complete', icon: 'check_circle'}
                ]; track step.num) {
                <div class="flex items-center" [class.flex-1]="step.num < 3">
                    <div class="flex items-center gap-2">
                        <div class="flex items-center justify-center w-10 h-10 rounded-full"
                            [class.bg-blue-600]="currentStep() >= step.num"
                            [class.text-white]="currentStep() >= step.num"
                            [class.bg-gray-200]="currentStep() < step.num"
                            [class.text-gray-500]="currentStep() < step.num">
                            <mat-icon>{{ step.icon }}</mat-icon>
                        </div>
                        <div>
                            <p class="text-sm font-medium" [class.text-blue-600]="currentStep() >= step.num"
                                [class.text-gray-500]="currentStep() < step.num">
                                Step {{ step.num + 1 }}
                            </p>
                            <p class="text-xs text-gray-500">{{ step.label }}</p>
                        </div>
                    </div>
                    @if (step.num < 3) { <div class="flex-1 h-0.5 mx-4" [class.bg-blue-600]="currentStep() > step.num"
                        [class.bg-gray-200]="currentStep() <= step.num">
                </div>
                }
            </div>
            }
        </div>
</div>
</jjames-card>

<!-- Step Content -->
<div class="step-content">
    @switch (currentStep()) {
    @case (0) {
    <app-create-parking-space-initial (parkingSpaceCreated)="onParkingSpaceCreated($event)" (cancel)="goBack()">
    </app-create-parking-space-initial>
    }
    @case (1) {
    <app-create-infrastructure-parking-space [parkingSpace]="createdParkingSpace()!"
        (infrastructureCreated)="onInfrastructureCreated($event)" (skip)="currentStep.set(3)">
    </app-create-infrastructure-parking-space>
    }
    @case (2) {
    <app-create-device-groups-parking-space [infrastructure]="createdInfrastructure()!"
        (deviceGroupsCreated)="onDeviceGroupsCreated($event)" (skip)="currentStep.set(3)">
    </app-create-device-groups-parking-space>
    }
    @case (3) {
    <app-create-parking-space-final [parkingSpace]="createdParkingSpace()!" [infrastructure]="createdInfrastructure()"
        [deviceGroups]="createdDeviceGroups()" (finish)="onFinish()">
    </app-create-parking-space-final>
    }
    }
</div>
</div>